import './init';

import { createApp } from 'vue';
import { createI18n, I18n } from 'vue-i18n';
import { createPinia } from 'pinia';

import App from '@/App.vue';

import penguify from '@/plugins/penguify';

import CubeLogger from '@/Logger';
import Formatters from '@/Formatters';

// Initialize i18n
export const i18n: I18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  globalInjection: true
});

// Import Vue Router
import router from '@/router/router';

import VueApexCharts from 'vue3-apexcharts';

import { useI18nStore } from '@/I18nStore';

import '@/directives';
import '@/assets/global.css';

import EnvironmentHandler from './EnvironmentHandler';

// Create Vue app
const app = createApp(App);
const pinia = createPinia();

const environmentUrl: string = window.location.origin + '/environment.json?date=' + new Date().getTime().toString();

window
  .fetch(environmentUrl)
  .then(response => response.json())
  .then(json => {
    // Logging needs to go first
    app.use(CubeLogger);

    console.log('Init env');
    EnvironmentHandler.init(json);

    // Use other plugins and store
    app.use(penguify);
    app.use(Formatters);
    app.use(pinia);
    app.use(i18n);
    app.use(VueApexCharts);
    app.use(router);

    const i18nStore = useI18nStore();
    i18nStore.init();

    app.mount('#app');
  });

export default i18n.global;
